import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { Box } from '@/box';
import LargeLoadingIndicator from '@/core/components/controls/LargeLoadingIndicator.component';
import { DomainError } from '@/errors';
import { useTranslation } from '@/i18n';
import { Card } from '@/ui/layout/Card.component';
import { Spacer } from '@/ui/spacing';
import { BodySmall, Heading } from '@/ui/typography';

export function CheckoutError({ error }: { error: unknown }) {
  const { t } = useTranslation('errors');

  const title = t(
    error instanceof DomainError
      ? error.titleTranslationKey ?? 'genericTitle'
      : 'genericTitle'
  );
  const message = t(
    error instanceof DomainError
      ? error.messageTranslationKey ?? 'generic'
      : 'generic'
  );

  return (
    <Box
      maxWidth={700}
      padding="32px 32px 132px 32px"
      margin="auto"
      flex={1}
      minHeight="100vh"
    >
      <Card>
        <Box paddingTop={20} paddingBottom={20}>
          <Heading as="h1" style="heading5" textAlign="center">
            {title}
          </Heading>

          <Spacer s="xs" />

          <Box textAlign="center" maxWidth="500px" margin="0 auto">
            <BodySmall>{message}</BodySmall>
          </Box>
        </Box>
      </Card>
    </Box>
  );
}

export function CheckoutPageSuspense(props: { children: React.ReactNode }) {
  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        return <CheckoutError error={error as unknown} />;
      }}
      onError={(error) => {
        console.error(error);
      }}
    >
      <Suspense
        fallback={
          <div style={{ height: 'calc(100vh - 40px)' }}>
            <LargeLoadingIndicator maxHeight={100} />
          </div>
        }
      >
        {props.children}
      </Suspense>
    </ErrorBoundary>
  );
}
